import { CalendarHeader } from './CalendarBody/CalendarHeader'
import { CalendarBody } from './CalendarBody/CalendarBody'
import { Box } from '@workwhile/ui'
import { RequestWorkersFlow } from '../../RequestWorkersFlow'
import { EditShiftFlow } from '../../EditShiftFlow'
import { RemoveWorkerFlow } from 'pages/AssignmentDetailPage/RemoveWorkerFlow'
import { CancelShiftFlow } from 'pages/AssignmentDetailPage/CancelShiftFlow'

export const CalendarView = () => {
  return (
    <Box>
      <CalendarHeader />
      <CalendarBody />
      <RequestWorkersFlow />
      <EditShiftFlow />
      <CancelShiftFlow />
      <RemoveWorkerFlow />
    </Box>
  )
}
